export default {
  bank_account: 'ACH Bank',
  card: 'Credit Card',
  cash: 'Cash',
  check: 'Check',
  other: 'Other'
};
